import * as React from 'react';
import { PanelsProps } from 'app/components/access-panel/types';
import { ExtraInfoPanel } from './extra-info-panel';
import { hasExtraInfoCodes } from './selectors';
import { sfNames } from 'app/components/access-panel/sf-names';
import style from 'app/area/administration/edit/edit.scss';
import { AdminPaperSubPanel } from 'app/area/administration/edit/components';

export interface ExtraInfoProps extends PanelsProps {
  extraInfoCodes: any;
}

export const ExtraInfo = (props: ExtraInfoProps) => {

  const { readOnly, data, clearValueInStore, formValues, formComponent, translation, validation, extraInfoCodes, simpleForm,
    roleSelected, roleBasedData, fetchingRoleBasedData, accessData, updateAccessData, clearValidation, endpoints,
    formOptions } = props;

  if (!hasExtraInfoCodes(extraInfoCodes)) {
    return null;
  }

  return <AdminPaperSubPanel title={translation.additional_information}>
    <div className={style.section}>
      <ExtraInfoPanel
        readOnly={readOnly}
        translation={translation}

        roleSelected={roleSelected}
        roleValue={roleBasedData && roleBasedData.additionalInformation}
        accessData={accessData && accessData.additionalInformation}
        updateAccessData={updateAccessData}
        fetchingRoleValue={fetchingRoleBasedData}

        formName={sfNames.additionalInformation}
        formComponent={formComponent}
        formValues={formValues}

        initialValue={data ? data.additionalInformation : []}
        extraInfoCodes={extraInfoCodes}
        validation={validation}
        clearValueInStore={clearValueInStore}
        clearValidation={clearValidation}

        valueOptionsEndpoint={endpoints.extraInfo}
        codeOptionsEndpoint={endpoints.extraInfoOptions}
        simpleForm={simpleForm}
        formOptions={formOptions} />
    </div>
  </AdminPaperSubPanel>;
};
